import React from 'react'
import style from './nodata.module.sass'
import { Button } from '../../helpers/commonUi'

interface IProps {
  image?: any,
  svg?: any,
  header?: string,
  content?: string,
  buttonText?: string,
  buttonCallback?: any,
  svgFill?: any,
  noButton?: boolean,
  buttonClassName?: string,
}

const NoData = (props: IProps) => {
  const SVG: any = props.svg
  return (
    <div className={style.wrapperContainer}>
      <div className={style.container}>
        {SVG ?
          <SVG style={{ color: props.svgFill }} />
          :
          props.image ?
            <img src={props.image} alt="img" />
            :
            null
        }
        <div className={style.header}>{props.header}</div>
        <div className={style.content}>
          {props.content}
        </div>
        {
          !props.noButton ?
            <div className={style.buttonContainer}>
              <Button
                dataTestId="get_started"
                color="shadow-secondary"
                size="small"
                onClick={props.buttonCallback}
                className={props.buttonClassName || ""}
              >
                {(props.buttonText && props.buttonText.toUpperCase()) || 'GET STARTED'}
              </Button>
            </div>
            :
            null
        }
      </div>
    </div>
  )
}

export default NoData